import { Region } from 'clickNgo/configs/geo'
import { PartnerHierarchyType } from 'clickNgo/entities/partner/configs'
import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

import { THierarchyTypeSource } from '../models'

interface IGetHierarchyTypeSourceParams {
  region: Region
  isNewPartner?: boolean
}

export const getHierarchyTypeSource = ({ region, isNewPartner }: IGetHierarchyTypeSourceParams) => {
  const source = new Crud({
    fetcher: new Static<THierarchyTypeSource>(
      Object.values(PartnerHierarchyType)
        .filter((value) => {
          if (value === PartnerHierarchyType.SUBSIDIARY) {
            return false
          }
          if (
            isNewPartner &&
            region === Region.AMS &&
            value === PartnerHierarchyType.RESELLER_NETWORK
          ) {
            return false
          }
          return true
        })
        .map((title, id) => ({
          id,
          title,
        }))
    ),
    keyField: 'title',
  })

  return source
}
